import { render, staticRenderFns } from "./ExternalPagesBanner.vue?vue&type=template&id=b74accce&"
import script from "./ExternalPagesBanner.vue?vue&type=script&lang=js&"
export * from "./ExternalPagesBanner.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPagesBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExternalPagesBanner.vue"
export default component.exports